/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-badge
 */

@use "sass:map";
@use "sass:color";
@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/fonts/open-sans.scss";
@use "../zr-theme/zr-variables.scss" as *;

$component: 'zr-badge';

// component vars defaults
$mhd-icon: map.get(i.$icons, "hourglass");
$b-stock-icon: map.get(i.$icons, "reload");
$zr-badge-discount-color: #D21942;
$zr-badge-discount-pink: #f6e0e3;

:host {
    --zr-badge-box-shadow-color: rgba(0 0 0 / 10%);
}

%#{$component} {
    box-sizing: border-box;
    border-radius: 10px 10px 0;
    display: block;
    width: max-content;
    padding: 2px 4px;
    margin-bottom: 8px;
    line-height: 0;
    box-shadow: 0 2px 4px var(--zr-badge-box-shadow-color);
    background-color: var(--ci-neutral200);
    color: var(--ci-neutral800);
    font-family: 'Open Sans', sans-serif;

    span {
        margin: 0;
        font-size: 10px;
        line-height: 14px;
        font-weight: 600;
        white-space: nowrap;

        &::before {
            background-size: contain;
            background-repeat: no-repeat;
            height: 10px !important;
            width: 10px !important;
            vertical-align: middle;
            margin-top: -2px;
            margin-right: -1px;
        }
    }
}

// Component Modifiers
.#{$component}--mhd {
    @extend %#{$component};
    border: 0.25px solid rgba(178 178 178 / 15%);

    span {
        @include i.icon-before;

        &::before {
            background-color: transparent;
            background-image: url($mhd-icon);
        }
    }
}

.#{$component}--b-stock {
    @extend %#{$component};

    span {
        @include i.icon-before;

        &::before {
            background-image: url($b-stock-icon);
            background-color: transparent;
        }
    }
}

.#{$component}--discount {
    @extend %#{$component};

    background-color: $zr-badge-discount-pink;
    border-color: rgba(210 25 66 / 15%);
    box-shadow: 0 2px 4px $zr-badge-discount-pink;

    span {
        color: $zr-badge-discount-color;
    }
}

.#{$component}--sponsor {
    @extend %#{$component};

    background-color: var(--ci-neutral800);
    border: none;
    box-shadow: 0 2px 4px var(--ci-neutral800);

    span {
        color: #fff;
    }
}

// Bind component placeholder to component class-selector
.#{$component} {
    @extend %#{$component};
}

@media only screen and (min-width: $tablet-screen) {
    %#{$component} {
        padding: 2px 6px;

        span {
            font-size: 14px;
            line-height: 20px;

            &::before {
                height: 14px !important;
                width: 14px !important;
            }
        }
    }

    :host {
        &.is-above-thumbnail {
            left: 120px;
        }
    }
}

